import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Col } from "@vertem-core/vertice-ds";
import React from "react";
import "Assets/styles/default/components/AlertAddress/AlertAddress.less";

const AlertAddress = () => {
 
  return (
    <>
        <Col className="container-alert-address">
          <ExclamationCircleOutlined className="exclamation-alert" />
          <p className="text-alert-address">
            Endereços de caixas postais não podem ser utilizados para entrega.
            Se o endereço fornecido for uma caixa postal, o pedido será
            cancelado automaticamente.
          </p>
        </Col>
    </>
  );
};

export default AlertAddress;
